import axios from "axios";

const LIMIT = 100;

const normalizeTransactionProductId = (tx) => {
  return (tx.id ?? tx.product_id ?? tx.product ?? "")
    .toString()
    .trim()
    .toLowerCase();
};

/** True when this row should not grant purchase-based access (e.g. refunded). */
const isRefundStatus = (status) => {
  const s = (status ?? "").toString().trim().toLowerCase();
  if (!s) return false;
  return s === "refund" || s === "refunded" || s.startsWith("refund");
};

/**
 * Fetches all pages of v3/my/past-transactions and returns a Set of normalized
 * product ids that still grant access (latest row per product id is not Refund).
 */
export const fetchAllPurchasedProductIds = async (
  apiUrl = process.env.REACT_APP_API2_URL
) => {
  const allRows = [];

  const firstRes = await axios.get(
    `${apiUrl}/v3/my/past-transactions?limit=${LIMIT}&offset=0`
  );
  let offset = LIMIT;
  let isLast = firstRes?.data?.is_last ?? true;
  const firstBatch = firstRes?.data?.data || [];
  allRows.push(...firstBatch);

  while (!isLast) {
    const { data } = await axios.get(
      `${apiUrl}/v3/my/past-transactions?limit=${LIMIT}&offset=${offset}`
    );
    const batch = data?.data || [];
    allRows.push(...batch);
    isLast = data?.is_last ?? true;
    offset += LIMIT;
  }

  // Assume rows are newest-first (offset 0 = latest). First occurrence per id = latest tx.
  const latestTxByProductId = new Map();
  for (const tx of allRows) {
    const id = normalizeTransactionProductId(tx);
    if (!id) continue;
    if (!latestTxByProductId.has(id)) {
      latestTxByProductId.set(id, tx);
    }
  }

  const activePurchasedIds = new Set();
  for (const [id, tx] of latestTxByProductId) {
    if (!isRefundStatus(tx.status)) {
      activePurchasedIds.add(id);
    }
  }

  return activePurchasedIds;
};
